import { BehaviorSubject } from 'rxjs';

export class CamposService {
    public id: string;
    
    obs: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    constructor(){}

}